import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}

if (window.location.hostname.includes('localhost'))
  environment.traduccion = "/assets/i18n/";

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
